import { Divider, Flex, Switch, SwitchProps, Text } from '@billy/design-system'
import { ReactElement } from 'react'

import * as Styled from './styles'

interface SwitchRowProps extends Omit<SwitchProps, 'children'> {
  bordered?: boolean
  label: string
}

export const SwitchRow = ({ bordered = true, label, ...switchRowProps }: SwitchRowProps): ReactElement => {
  return (
    <>
      <Styled.SwitchRowWrapper>
        <Flex justifyContent="space-between">
          <Text colorVariant="secondary">{label}</Text> <Switch {...switchRowProps} />
        </Flex>
      </Styled.SwitchRowWrapper>
      {bordered && <Divider />}
    </>
  )
}
